import { Button, Spinner } from '@chakra-ui/react';
import { WIDGET_TYPES } from '../../Library/widgets';
import { Sheet } from '../../Templates';
import { AddModelIcon } from '../../Assets/images/svgs';
import { useNavigate } from 'react-router-dom';
import PATH from '../../Routes/paths';
import { useCallback, useEffect, useState } from 'react';
import { getBatteriesStatsByManf, getVehicleModelsCount } from '../../APIs';
import './style.css';


const INVENTORY_LAYOUT = [
  [WIDGET_TYPES.BATTERIES_STATS, WIDGET_TYPES.VEHICLES_STATS],
]


const Inventory = () => {
  const Navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({ vehicleStats: [], batteryStats: [] });

  const fetchWidgetsData = useCallback(async () => {
    setIsLoading(true);

    try {
      let vehData = await getVehicleModelsCount();
      let batData = await getBatteriesStatsByManf();

      setData(prev => ({ ...prev, 'vehicleStats': vehData, batteryStats: batData }))      
    } catch (e) {
      console.error("Error while fetching Widget Data Inventory", e);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchWidgetsData();
  }, [fetchWidgetsData]);

  return (
    <div className='panel-main'>
      <div className='add-btn-cont'>
        {
          data.batteryStats.length ? <Button
            leftIcon={<AddModelIcon />}
            className="add-btn"
            onClick={() => Navigate(PATH.ADDBATTERY)}
          >
            Add New Battery
          </Button> : <div></div>
        }
        {
          data.vehicleStats.length ? <Button
            leftIcon={<AddModelIcon />}
            className="add-btn"
            onClick={() => Navigate(PATH.ADDVEHICLE)}
          >
            Add New Vehicle
          </Button> : null
        }
      </div>
      <main>
        {!isLoading ? <Sheet layout={INVENTORY_LAYOUT} data={data} /> : (
          <div className="widget-loader">
            <Spinner />
          </div>
        )}
      </main>
    </div>
  )
}

export default Inventory;